/* JELO · Variante bajo galería. Mueve el selector existente; no lo duplica. */
(() => {
  'use strict';
  let pending = false;
  const relocate = () => {
    document.querySelectorAll('product-component[data-product-grid-content]').forEach((grid) => {
      const dock = grid.querySelector('[data-jelo-variant-dock]');
      if (!dock) return;
      const target = dock.querySelector('[data-jelo-variant-content]');
      const picker = grid.querySelector('.product-details variant-picker') || grid.querySelector('variant-picker');
      if (!target || !picker) return;
      if (picker.parentElement !== target) target.appendChild(picker);
      dock.hidden = false;
    });
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; relocate(); });
  };
  const start = () => {
    relocate();
    const root = document.querySelector('main') || document.body;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
